<template>
  <div id="app">
    <Space/>
  </div>
</template>

<script>
import Space from './components/Space.vue'

export default {
  name: 'App',
  components: {
    Space
  }
}
</script>